export const PRODUCTS_TYPES_FORMATS = {
  LIST: '70x80',
  MOSAIC: '140x160',
  SEARCH: '85x97',
};

export const CART_ITEM_FORMATS = {
  phone: '85x97',
  tablet: '140x160',
};

export const HOME_PROMOTION_BLOCK_FORMATS = {
  phone: '375x220',
  tablet: '418x402',
  desktop: '900x530',
  large: '900x530',
  full: '900x530',
};

export const HOME_SLIDES_FORMATS = {
  phone: '700x700',
  tablet: '290x290',
  desktop: '550x550',
  large: '550x550',
  full: '550x550',
};

export const HOME_JOBS_FORMATS = {
  phone: '252x323',
  tablet: '264x339',
  desktop: '264x339',
  large: '300x385',
  full: '300x385',
};

export const HOME_PROMOTION_FORMATS = {
  phone: '345x213',
  tablet: '354x350',
  desktop: '462x350',
  large: '631x350',
  full: '631x350',
};

export const HOME_PARTNERS_FORMATS = {
  phone: '64x64',
  tablet: '95x95',
  desktop: '118x118',
  large: '118x118',
  full: '118x118',
};

export const PARTNERS_FORMATS = {
  phone: '64x64',
  tablet: '95x95',
  desktop: '118x118',
  large: '118x118',
  full: '118x118',
};

export const MENU_CATEGORIES_FORMAT = '30x30';
